import { ReactElement } from 'react';

import Login from '@/components/pages/Login';

/**
 * Login page
 * Route: /login
 *
 * IMPORTANT: This page is in Pages Router (not App Router) because:
 * - The Login component uses useUser() hook which depends on Redux state
 * - Redux initialization happens in Pages Router's AppProviders/AuthenticatedPage wrapper
 * - App Router and Pages Router have separate React trees with separate provider contexts
 * - Attempting to use Redux-dependent components in App Router results in uninitialized state (isUserLoading stays true forever)
 * - This was causing an infinite loading spinner when /login was in App Router
 *
 * Note: This page is excluded from AuthenticatedPage's auth redirect (see _app.tsx isPublicRoute check)
 * but still gets Redux initialization from AppProviders wrapper.
 */
export default function LoginPage(): ReactElement {
	return <Login />;
}
